module.exports = __webpack_public_path__ + "img/effects-14.66d275d5.png";